import create from 'zustand';

type AlertModalState = {
  open: boolean;
  header: string;
  bodyTxt: string;
  buttonText: string;
  cancelText: string;
  handleConfirmation: () => void;
  handleCancel: () => void;
  handleClose: () => void;
  openModal: (
    props: Partial<Omit<AlertModalState, 'open' | 'openModal' | 'closeModal'>>,
  ) => void;
  closeModal: () => void;
};

const useAlertModalStore = create<AlertModalState>(set => ({
  open: false,
  header: 'Confirm',
  bodyTxt: '',
  buttonText: 'OK',
  cancelText: '',
  handleConfirmation: () => {},
  handleCancel: () => {},
  handleClose: () => set({open: false}),
  openModal: ({
    header,
    bodyTxt,
    buttonText,
    cancelText,
    handleConfirmation,
    handleCancel,
    handleClose,
  }) =>
    set({
      open: true,
      header: header || 'Confirm',
      bodyTxt: bodyTxt || '',
      buttonText: buttonText || 'OK',
      cancelText: cancelText || '',
      handleConfirmation: handleConfirmation || (() => {}),
      handleCancel: handleCancel || (() => set({open: false})),
      handleClose: handleClose || (() => set({open: false})),
    }),
  closeModal: () => set({open: false}),
}));

export default useAlertModalStore;
